import { useState } from 'react';
import AuthLayout from '../components/AuthLayout';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    const res = await fetch('/api/auth/request-reset', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email }) });
    setMsg(res.ok ? 'If the email exists, a reset link was sent or logged.' : 'Request failed');
  }

  return (
    <AuthLayout title="Forgot password">
      <form className="space-y-4" onSubmit={submit}>
        <div className="grid gap-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <Button type="submit" className="w-full">Send reset link</Button>
      </form>
      <div className="mt-3 text-right">
        <a href="/" className="text-sm text-primary underline-offset-4 hover:underline">Back to sign in</a>
      </div>
      {msg && <p className="mt-4 text-sm text-muted-foreground">{msg}</p>}
    </AuthLayout>
  );
}

